import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';

import { Toast } from '@/components/Toast/Toast.tsx';
import { helpers } from '@/helpers.ts';
import { MessageTypesUI } from '@/enums/viewEnums.ts';

export const FormErrors = () => {
  const {
    formState: { errors }
  } = useFormContext();

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const message = Object.values(errors)
        .filter((error) => error?.message)
        .map((error) => error?.message || '');

      helpers.toast({
        id: MessageTypesUI.TYPE_SYSTEM_ERROR,
        content: (
          <Toast
            type={MessageTypesUI.TYPE_SYSTEM_ERROR}
            msg={message[0] as string}
          />
        )
      });
    }
  }, [errors]);

  return null;
};
